// convert string from snake_case to camelCase
const snakeToCamel = function (str) {
  if (str === void 0) {
    str = '';
  }
  return str.replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));
};

// clones snakecase keyed properties with camelCase keyed properties
export default function cloneSnakeCaseProperties(acc, _ref) {
  let [key, value] = _ref;
  acc[key] = value;
  if (key.includes('-') || key.includes('_')) {
    acc[snakeToCamel(key)] = value;
  }
  return acc;
}